import { PAYMENT_METHOD } from 'components/common/constants';
import { isLikelyIban } from 'services/utils';

export default function UseTemplateModel(templateData) {
  if (!templateData) return {};

  const { amount, currency, comment, paymentMethod, requisites = {}, beneficiary = {}, paymentPurpose } = templateData;

  // Legacy SWIFT templates stored the IBAN in requisites.accountNumber with requisites.iban left empty
  const iban = requisites?.iban || (isLikelyIban(requisites?.accountNumber) ? requisites.accountNumber : null);

  // INTERNAL templates store the recipient's internal wallet number in requisites.accountNumber —
  // it belongs in the recipient (IBAN / wallet) field, not in the UK account number field
  const internalWalletNumber =
    !iban && paymentMethod === PAYMENT_METHOD.INTERNAL ? requisites?.accountNumber || null : null;

  // account_number must hold only a UK local account number. When requisites.accountNumber was consumed
  // as the recipient value (an IBAN or an internal wallet number), or the template is INTERNAL (internal
  // transfers never use the UK account number + sort code pair), it must stay out of account_number —
  // otherwise the recipient IBAN input is rendered disabled (isDisabled={!!values.account_number})
  const isAccountNumberUsedAsRecipient =
    iban === requisites?.accountNumber || paymentMethod === PAYMENT_METHOD.INTERNAL;

  // Формируем объект counterparty на основе типа платежа и данных бенефициара
  const counterparty = {
    iban: iban || internalWalletNumber,
    bic: requisites?.bic || null,
    // beneficiary.type is the backend AccountType enum: CORPORATE | INDIVIDUAL (same as UpdateTemplateModel)
    party_name:
      beneficiary?.type === 'CORPORATE'
        ? beneficiary?.companyName
        : `${beneficiary?.firstName || ''} ${beneficiary?.lastName || ''}`.trim(),
    first_name: beneficiary?.firstName || null,
    last_name: beneficiary?.lastName || null,
    wallet_number: null,
    bank_name: requisites?.bankName || null,
    bank_country: requisites?.bankCountry || null,
    bank_address: null,
    registration_number: beneficiary?.registrationNumber || null,
    party_city: beneficiary?.city || null,
    party_country: beneficiary?.country || null,
    post_code: beneficiary?.postCode || null,
    party_state: beneficiary?.state || null,
    party_address: beneficiary?.address || null,
    account_number: isAccountNumberUsedAsRecipient ? null : requisites?.accountNumber || null,
    sort_code: requisites?.sortCode || null,
    crypto_wallet: requisites?.cryptoAddress || null,
    network: requisites?.cryptoNetwork || null,
    party_type: beneficiary?.type || null
  };

  return {
    type: null,
    status: null,
    amount: amount || null,
    comment: comment || null,
    purpose: paymentPurpose || null,
    documents: null,
    counterparty,
    id: null,
    wallet_number: null,
    iban: null,
    account_number: null,
    sender_name: null,
    sender_country: null,
    sender_bank: null,
    sender_bank_country: null,
    sender_bank_bic: null,
    sender_wallet_number: null,
    recipient_name: null,
    recipient_bank: null,
    recipient_bank_country: null,
    recipient_bank_bic: null,
    recipient_wallet_number: null,
    transaction_number: null,
    transaction_type: null,
    transfer_type: null,
    created_at: null,
    updated_at: null,
    source_amount: null,
    amount_default: null,
    currency_code: currency || null,
    target_amount: null,
    commission_type: null,
    total_commissions: null,
    commission_default: null,
    applied_rate: null,
    comment_to_admin: null,
    error_message: null,
    token_client_details: null,
    is_pdf_available: false,
    recipient_type: null,
    payment_method: paymentMethod || null,
    hold_details: null,
    related_transaction_number: null,
    external_reference: null,
    document_status: null,
    error_reason: null,
    authorization_info: null,
    mlro_approval: null,
    mlro_updated_at: null,
    mlro_updated_by: null,
    crypto_hash: null,
    crypto_address: requisites?.cryptoAddress || null,
    network: requisites?.cryptoNetwork || null
  };
}
